import {
  useProducts,
  type ProductType,
  type Prompt,
} from "@1js/pl-card-components";
import React from "react";
import { usePromptActions } from "../../../hooks/usePromptActions";

export type LoaderStateType = "loading" | "error" | "copy";

export type LoaderHookProps = {
  onCopy: () => void;
  onCancel: () => void;
  destination: ProductType | string;
  prompt: Prompt;
};

export type LoaderHookResult = {
  onCancel: () => void;
  onCopy: () => void;
  productName: string;
  isCopied: boolean;
};

export const useLoader = (props: LoaderHookProps): LoaderHookResult => {
  const { onCopy, onCancel, destination, prompt } = props;

  const { badgeToLabel } = useProducts();
  const productName = badgeToLabel(destination);

  const { handleCopyClicked } = usePromptActions();

  const [isCopied, setIsCopied] = React.useState(false);

  const onCopyHooked = React.useCallback(() => {
    handleCopyClicked(prompt, () => setIsCopied(true));
    onCopy();
  }, [handleCopyClicked, onCopy, prompt]);

  return {
    onCopy: onCopyHooked,
    onCancel,
    productName,
    isCopied,
  };
};
